const TEST_ACCOUNT_EMAILS = ["testing@ent.com", "testing@pro.com"];

export const alertTestAccountEvent = (email, eventType, data) => {
  if (!email || !TEST_ACCOUNT_EMAILS.includes(email.toLowerCase())) return;
  // eslint-disable-next-line no-alert
  alert("Event key is : " + eventType + "\n" + "Passed Data is : " + JSON.stringify(data));
};
